import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { Fragment } from 'react';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { getAllChildrenStrings, markNestedTypes } from '../../utils';
import { getHeadingId } from '../CreditCardsTableOfContents/utils';
type Variant = 'title' | 'textLargeBold' | 'textLarge' | 'textBold' | 'text' | 'textSmall';
const headingStyleMap: Record<number, Variant> = {
  1: 'title',
  2: 'textLargeBold',
  3: 'textLarge',
  4: 'textBold',
  5: 'text',
  6: 'textSmall'
};
export type ContentHeadingProps = StructuredContentDocumentWithRenderer<{
  level: 1 | 2 | 3 | 4 | 5 | 6;
  size?: 5 | 4 | 3 | 2 | 1 | 0;
  children: StructuredContentDocument | [string];
}>;
export const ContentHeading = sccProps => {
  const $ = _c(13);
  const {
    props
  } = sccProps;
  const component = `h${props.level}`;
  const variant = headingStyleMap[props.level];
  let id;
  let t0;
  if ($[0] !== sccProps) {
    const childrenString = getAllChildrenStrings(sccProps);
    t0 = getHeadingId(childrenString);
    $[0] = sccProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const slugifiedId = t0;
  if (props.level === 2) {
    id = slugifiedId;
  }
  const t1 = `content-heading-${slugifiedId}`;
  let t2;
  if ($[2] !== id) {
    t2 = id && {
      id
    };
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      lineHeight: "inherit !important"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.children) {
    t4 = [props.children].flat().map(_temp);
    $[5] = props.children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== component || $[8] !== t1 || $[9] !== t2 || $[10] !== t4 || $[11] !== variant) {
    t5 = <Typography component={component} variant={variant} data-testid={t1} {...t2} sx={t3}>{t4}</Typography>;
    $[7] = component;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = variant;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(child, idx) {
  if (typeof child === "string") {
    return <Box key={`content-heading-${idx}`} component="span" sx={{
      whiteSpace: "pre-wrap"
    }}>{child}</Box>;
  }
  return <Fragment key={`content-heading-doc-${idx}`}>{renderStructuredContent(markNestedTypes(child))}</Fragment>;
}